// @ts-nocheck



import CommonApi from './../commonApi';
import { convertFromKopToRub, convertFromRubToKop } from '../pure/unitConversions';

export const convertDataToServer = (passTariff) => ({
  ...passTariff,
  excessRate: convertFromRubToKop(passTariff.excessRate),
  roadDamageRate: convertFromRubToKop(passTariff.roadDamageRate),
  springPassesTax: convertFromRubToKop(passTariff.springPassesTax),
  cargoPassesAgreementTax: convertFromRubToKop(
    passTariff.cargoPassesAgreementTax
  ),
  cargoPassesTax: convertFromRubToKop(passTariff.cargoPassesTax),
  blankPrice: convertFromRubToKop(passTariff.blankPrice)
});

export const convertDataFromServer = (passTariff) => ({
  ...passTariff,
  excessRate: convertFromKopToRub(passTariff.excessRate),
  roadDamageRate: convertFromKopToRub(passTariff.roadDamageRate),
  springPassesTax: convertFromKopToRub(passTariff.springPassesTax),
  cargoPassesAgreementTax: convertFromKopToRub(
    passTariff.cargoPassesAgreementTax
  ),
  cargoPassesTax: convertFromKopToRub(passTariff.cargoPassesTax),
  blankPrice: convertFromKopToRub(passTariff.blankPrice)
});

const passTariff = new CommonApi(
  'passTariff',
  'Тарифы на пропуска',
  convertDataToServer,
  convertDataFromServer
);

export default passTariff;
